import "../styles/remote-stores.css";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import ServiceController from "../services/service-controller";
import { Skeleton } from "primereact/skeleton";
import { Carousel } from "primereact/carousel";

export default function SpecialRemoteStores(props) {
	const { t } = useTranslation();
	const serviceController = new ServiceController();
	const [isLoading, setIsLoading] = useState(false);
	const [stores, setStores] = useState([]);

	const getData = async function () {
		try {
			setIsLoading(true);
			const storesResult = await serviceController.getRemoteStores(
				"",
				"ویژه-تاکسیرانی"
			);
			if (storesResult.isSuccess === false) throw storesResult.message;
			for (let i = getTotal(); i >= storesResult.value.length; i--) {
				storesResult.value.push({});
			}
			setStores(storesResult.value);
		} catch (error) {
			alert(error.toString());
		}
		setIsLoading(false);
	};

	useEffect(() => {
		getData();
	}, []);

	const storeTemplate = (store) => {
		if (!store.code) return <div ></div>;
		else
			return (
				<a className="r-store" href={`/#/remote-store-details/?code=${store.code}`}>
					<img src={store.imageUrl} />
					<div>
						<h2>{store.name}</h2>
						<p>{store.offPercent} % </p>
					</div>
					<a href={`/#/remote-store-details/?code=${store.code}`}>
						مشاهده جزییات بیشتر...
					</a>
				</a>
			);
	};

  const getTotal = () => {
    if (window.innerWidth >= 1200) return 4;
    else if (window.innerWidth >= 992) return 3;
    else if (window.innerWidth >= 576) return 2;
    else return 1;
  }

	return (
		<div>
			<h3>فروشگاه های ویژه</h3>
			{isLoading === true && (
				<>
					<div className="flex gap-4 mb-4">
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
					</div>
				</>
			)}

			<Carousel
				value={stores}
				numVisible={getTotal()}
				numScroll={1}
				itemTemplate={storeTemplate}
				autoplayInterval={7000}
        showNavigators={false}
				circular
			/>
		</div>
	);
}
